import { isString, isObjectLike, size } from "lodash";
import * as types from "../../types";

export default {
  [types.RESPONSES_RESET](state, { submission_token } = {}) {
    state.responses.splice(0, state.responses.length);
    state.submission_token = submission_token || null;
  },

  [types.RESPONSES_SET](state, { id, value }) {
    const currentIndex = state.responses.findIndex(response => response.id === id);

    if (currentIndex >= 0) {
      state.responses.splice(currentIndex, 1);
    }

    if (isObjectLike(value) && size(value) === 0) {
      // its an empty array or object
      return;
    }

    if (isString(value) && value.trim().length === 0) {
      return;
    }

    state.responses.push({ id, value });
  },
};
